import { useEffect, useState } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Cursor from './components/Cursor';
import Loader from './components/Loader';
import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import BentoGrid from './components/BentoGrid';
import Manifesto from './components/Manifesto';
import StackedPanels from './components/StackedPanels';
import Statement from './components/Statement';
import Footer from './components/Footer';

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const [loaderDone, setLoaderDone] = useState(false);

  useEffect(() => {
    if (!loaderDone) return;
    if (typeof window === 'undefined') return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      ScrollTrigger.refresh();
      return;
    }

    const lenis = new Lenis({
      lerp: 0.1,
      wheelMultiplier: 1,
      smoothWheel: true,
    });

    lenis.on('scroll', ScrollTrigger.update);

    const rafCallback = (time: number) => {
      lenis.raf(time * 1000);
    };

    gsap.ticker.add(rafCallback);
    gsap.ticker.lagSmoothing(0);

    const onResize = () => ScrollTrigger.refresh();
    window.addEventListener('resize', onResize);

    // Ensure a refresh after mount
    const timer = window.setTimeout(() => ScrollTrigger.refresh(), 400);

    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('resize', onResize);
      gsap.ticker.remove(rafCallback);
      lenis.destroy();
    };
  }, [loaderDone]);

  return (
    <>
      <Cursor />
      <Loader onComplete={() => setLoaderDone(true)} />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <BentoGrid />
        <Manifesto />
        <StackedPanels />
        <Statement />
        <Footer />
      </main>
    </>
  );
}